<template>
  <div class="bb-loader-select" v-click-outside="closeDropdownMenu" @mouseleave="closeDropdownMenu">
    <div class="bb-loader-select-header"
         :class="{
           'bb-loader-select-header_error': error,
           'bb-loader-select-header_view-mode': viewMode
         }"
         ref="bbSelectHeader"
         @click="openDropdownMenu">
      <div class="bb-loader-select-header-selected">
          <span class="bb-loader-select-header-selected__value"
                @click.stop="clickBySelect"
                :class="{
                  'bb-loader-select-header-selected__value_tag': type === 'tag',
                  'bb-loader-select-dropdown-menu-item_yellow': value.color === 'yellow',
                  'bb-loader-select-dropdown-menu-item_green': value.color === 'green',
                  'bb-loader-select-dropdown-menu-item_red': value.color === 'red',
                  }"
                v-if="selectedValue || selectedValue === 0">
            <i class="bb-loader-select-dropdown-menu-item__icon"
               :class="['icon-' + value.icon]"
               v-if="value.icon"/>
          {{selectedValue}}
          <i class="icon-cross bb-loader-select-header-selected__remove"
             v-if="clearable"
             @click.stop="removeValue()"/>
        </span>
        <span class="bb-loader-select-header-selected__placeholder" v-else>
          {{placeholder || ''}}
        </span>
      </div>
      <i class="icon-arrow-select bb-loader-select-header__arrow"
         v-if="!viewMode"
         :class="{'bb-loader-select-header__arrow_active': displayDropdownMenu}"/>
      <input class="bb-loader-select-header__search"
             v-if="searchable"
             type="text"
             @blur="clearInput"
             @input="changeInput"/>
    </div>
    <transition name="slide-select">
      <div>
        <div v-show="displayDropdownMenu" class="bb-loader-select-dropdown-menu-margin"/>
        <VuePerfectScrollbar class="bb-loader-select-dropdown-menu"
                             :class="{'bb-loader-select-dropdown-menu_tag': type === 'tag',
                                      'bb-loader-select-dropdown-menu_width': minWidth
                                     }"
                             :settings="scrollSettings"
                             ref="bbSelectDropdownMenu"
                             v-show="displayDropdownMenu">
          <div class="bb-loader-select-dropdown-menu__empty bb-loader-select-dropdown-menu__empty_top"/>
          <div class="bb-loader-select-dropdown-menu-item"
               :class="{
               'bb-loader-select-dropdown-menu-item_tag': type === 'tag',
               'bb-loader-select-dropdown-menu-item_tag_selected': type === 'tag' && value && value.id === option.id,
               'bb-loader-select-dropdown-menu-item_selected': value && value.id === option.id,
               'bb-loader-select-dropdown-menu-item_yellow': option.color === 'yellow',
               'bb-loader-select-dropdown-menu-item_green': option.color === 'green',
               'bb-loader-select-dropdown-menu-item_red': option.color === 'red',
               'bb-loader-select-dropdown-menu-item_last-item': index === optionsSorted.length - 1,
             }"
               v-for="(option, index) in optionsSorted"
               :key="option.id"
               @click="setValue(option)">
            <i class="bb-loader-select-dropdown-menu-item__icon"
               :class="['icon-' + option.icon]"
               v-if="option.icon"/>
            {{option[label]}}
          </div>
          <div class="bb-loader-select-dropdown-menu__empty bb-loader-select-dropdown-menu__empty_bot"/>
        </VuePerfectScrollbar>
      </div>
    </transition>
  </div>
</template>

<script>
import {get, orderBy} from 'lodash'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  name: 'BBSelect',
  components: {
    VuePerfectScrollbar
  },
  props: [
    'model',
    'searchable',
    'clearable',
    'options',
    'label',
    'value',
    'disabled',
    'minWidth',
    'maxHeight',
    'multiple',
    'placeholder',
    'orderBy',
    'error',
    'type',
    'item',
    'viewMode'
  ],
  data () {
    return {
      displayDropdownMenu: false,
      scrollSettings: {
        wheelPropagation: false
      }
    }
  },
  computed: {
    optionsSorted () {
      const keys = get(this.orderBy, 'keys', [])
      const order = get(this.orderBy, 'order', [])
      return orderBy(this.options, [...keys], [...order])
    },
    selectedValue () {
      return get(this.value, this.label, '')
    }
  },
  methods: {
    setValue (value) {
      this.closeDropdownMenu()
      this.$emit('change', value, this.item)
    },
    clickBySelect () {
      if (!this.value.popup) {
        this.openDropdownMenu()
      }
      this.$emit('clickBySelected', this.value)
    },
    closeDropdownMenu () {
      this.displayDropdownMenu = false
    },
    openDropdownMenu () {
      if (this.viewMode) return
      this.calcFixedPosition()
      this.displayDropdownMenu = !this.displayDropdownMenu
    },
    clearInput (e) {
      e.target.value = ''
    },
    changeInput (e) {
      // e.target.value
    },
    removeValue () {
      this.setValue('')
    },
    setFixedPosition ({top, left, width, height}) {
      const dropdownMenuSelect = get(this.$refs, 'bbSelectDropdownMenu.$el', '')
      if (!dropdownMenuSelect) return
      dropdownMenuSelect.style.position = 'fixed'
      dropdownMenuSelect.style.top = top + height + 'px'
      dropdownMenuSelect.style.left = left + 'px'
      dropdownMenuSelect.style.width = width + 'px'
    },
    calcFixedPosition () {
      const headerSelect = get(this.$refs, 'bbSelectHeader', '')
      if (!headerSelect) return
      const headerSelectPosition = headerSelect.getBoundingClientRect()
      const width = headerSelect.offsetWidth
      const height = headerSelect.offsetHeight
      const left = headerSelectPosition.left
      const top = headerSelectPosition.top + 4
      this.setFixedPosition({top, left, width, height})
    }
  },
  watch: {
    displayDropdownMenu () {
      this.$emit('dropdownOpen', this.displayDropdownMenu)
    }
  },
  mounted () {
    window.addEventListener('resize', this.closeDropdownMenu, false)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.closeDropdownMenu, false)
  }
}
</script>

<style lang="scss">
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bb-loader-select {
    @include global-font;
    font-weight: 500;
    font-size: inherit;
    height: 100%;
    width: 100%;

    &-header {
      display: flex;
      align-items: center;
      height: 100%;
      position: relative;
      box-sizing: border-box;
      border-radius: 5px;
      padding: 5px 8px;
      cursor: pointer;

      &_view-mode {
        border-color: transparent;
        cursor: default;
        margin-left: -10px;
      }

      &_error {
        border-color: $color-red-orange;
        transition: 0.3s;
      }

      &-selected {
        display: inline-flex;

        &__placeholder {
          color: $color-silver;
          pointer-events: none;
          user-select: none;
        }

        &__value {
          display: flex;
          align-items: center;
          padding: 2px 5px;
          border-radius: 3px;

          &_tag {
            color: $color-accent;
            background: rgba($color-accent, 0.2);
          }
        }

        &__remove {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 15px;
          height: 15px;
          margin: -3px -3px -3px 1px;
          font-size: 12px;
          color: rgba($color-accent, 0.5);
          cursor: pointer;
          transition: 0.4s;

          &:hover {
            color: rgba($color-accent-hover, 0.5);
          }
        }
      }

      &__arrow {
        position: absolute;
        right: 9px;
        color: $color-accent;
        font-size: 5px;
        transition: 0.3s ease;

        &_active {
          transform: rotate(180deg);
        }
      }

      &__search {
        position: absolute;
        width: calc(100% - 25px);
        height: calc(100% - 2px);
        top: 1px;
        left: 1px;
        padding: 5px 0 5px 15px;
        opacity: 0;
        border-radius: 5px;
        border: none;

        &:focus {
          opacity: 1;
        }
      }
    }

    &-dropdown-menu {
      overflow: hidden;
      display: grid;
      align-items: center;
      position: relative;
      width: 100%;
      min-width: 110px;
      background: $color-white;
      box-shadow: 0 0 12px rgba($color-black, 0.12);
      border-radius: 5px;
      padding-left: 8px;
      color: $color-black;
      z-index: 1000;
      max-height: 150px;

      &-margin {
        width: 100%;
        height: 4px;
        background-color: transparent;
      }

      &_width {
        min-width: 82px;
      }

      &_tag {
        display: inline-flex;
        flex-wrap: wrap;
        color: $color-accent;
      }

      &__empty {
        position: sticky;
        width: 100%;
        height: 8px;
        background-color: $color-white;
        margin-right: 8px;
        z-index: 1;

        &_top {
          top: 0;
          margin-bottom: -8px;
        }

        &_bot {
          bottom: 0;
        }
      }

      &-item {
        display: inline-flex;
        align-self: center;
        padding: 3px 5px;
        border-radius: 3px;
        margin: 8px 8px 0 0;
        transition: 0.3s;
        line-height: calc(100% + 1px);
        cursor: pointer;

        &_last-item {
          padding-bottom: 10px;
        }

        &_selected {
          pointer-events: none;
          color: $color-accent;
        }

        &:hover {
          opacity: 0.8;
          color: $color-accent-hover;
        }

        &_yellow {
          color: $color-la-rioja;
          &:hover {
            opacity: 0.8;
            color: $color-la-rioja;
          }
        }

        &_green {
          color: $color-japanese-laurel;
          &:hover {
            opacity: 0.8;
            color: $color-japanese-laurel;
          }
        }

        &_red {
          color: $color-pomegranate;
          &:hover {
            opacity: 0.8;
            color: $color-pomegranate;
          }
        }

        &_tag {
          background: rgba($color-accent, 0.2);

          &_selected {
            background: rgba($color-silver-chalice, 0.2);
            color: $color-silver-chalice;
          }

          &:hover {
            background: rgba($color-accent-hover, 0.2);
          }
        }

        &__icon {
          font-size: 13px;
          margin-right: 6px;

          &:before {
            margin: 0;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/Inputs/BBSelect.vue